export default {"src":"/_next/static/media/real-time-quotes.c6e90b5d.svg","height":48,"width":48};